import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { VehicleMetadataComponentAbstract } from '../../metadata-components/vehicle-metadata/vehicle-metadata.component.abstract';

@Component({
  selector: 'app-vehicle-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent],
  templateUrl: './vehicle-metadata-v2.component.html',
})
export class VehicleMetadataV2Component extends VehicleMetadataComponentAbstract {}
